<template>
  <div :class="`${el}__features`">
    <Row>
      <Col :xs="12" :l="6" :class="`${el}__benefitItemRelative`">
        <div :class="`${el}__benefitItemRelative`">
          <Copy
            element="div"
            color="primaryBlue"
            :staticClass="`${el}__featuresOverline`"
            bold
            :centered="!$matchMedia.l"
          >
            {{ $t('cs.title') }}
          </Copy>
          <Headline
            size="m"
            :heading="3"
            :staticClass="`${el}__featuresHeadline`"
            :centered="!$matchMedia.l"
            responsive
          >
            {{ $t('home.features.headline') }}
          </Headline>
          <Copy
            staticClass="u-margin__bottom--4"
            element="div"
            :centered="!$matchMedia.l"
            responsive
          >
            {{ $t('home.features.copy') }}
          </Copy>
        </div>

        <div v-if="!$matchMedia.l" :class="`${el}__featuresImages`">
          <div :class="`${el}__featuresImage`">
            <Picture
              :img="$t('home.features.image.v2')"
              responsive
              :class="`${el}__benefitItemRelative`"
              :width="351"
              :height="479"
            />
          </div>
          <Picture
            :img="$t(!$matchMedia.s ? 'home.features.brush.mobile' : 'home.features.brush')"
            :width="$matchMedia.l ? 1164 : 375"
            :height="$matchMedia.l ? 800 : 796"
            :class="`${el}__brush`"
          />
        </div>
      </Col>
      <Col v-if="$matchMedia.l" :xs="12" :l="6" :class="`${el}__featuresImages`">
        <div :class="`${el}__featuresImage`">
          <Picture :img="$t('home.features.image.v1')" :width="597" :height="518" responsive />
        </div>
        <Picture
          :img="$t('home.features.brush')"
          :width="1164"
          :height="800"
          :class="`${el}__brush`"
        />
      </Col>
    </Row>
  </div>
</template>

<script>
import Copy from '@/objects/Copy';
import Headline from '@/objects/Headline';
import Picture from '@/objects/Picture';
import Row from '@/components/Grid/Row';
import Col from '@/components/Grid/Col';
// import Tracking from '@/helpers/tracking/Tracking';

export default {
  name: 'Features',
  props: {},
  components: {
    Copy,
    Headline,
    Picture,
    Row,
    Col,
  },
  data() {
    return {
      el: 'v-home',
    };
  },
};
</script>
